let failure: Error | undefined;
const listeners = new Set<() => void>();
export function vaultFailure() { return failure; }
export function reportVaultFailure(_cause: unknown) {
  failure ??= new Error('Dein Lerntresor konnte nicht sicher gespeichert oder gelesen werden. Sichere deinen verfügbaren Lernstand und starte FUSICS erneut.');
  for (const listener of listeners) listener();
}
export function onVaultFailure(listener: () => void) {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}
export function isStorageFailure(error: unknown) {
  return error instanceof Error && ['QuotaExceededError', 'InvalidStateError', 'UnknownError', 'VersionError', 'OperationError', 'DataError', 'AbortError'].includes(error.name);
}
